import React from 'react';
import { useOrionUI } from 'src/common/hooks/useOrionUI';
import LandingOrion from './LandingPageOrion';
import LandingClassic from './LandingPageClassic';

export default function Landing(): JSX.Element {
  return useOrionUI() ? <LandingOrion /> : <LandingClassic />;
}
